import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TimeService } from 'src/app/time.service';


@Component({
  selector: 'app-view-driver',
  templateUrl: './view-driver.component.html',
  styleUrls: ['./view-driver.component.scss']
})
export class ViewDriverComponent implements OnInit {

  driverData: any = {};
  constructor(private dialog: MatDialogRef<ViewDriverComponent>,
    @Inject(MAT_DIALOG_DATA) private parentData: any, private timeService: TimeService) { }

  ngOnInit() {
    this.driverData.driverName = this.parentData.driverName ? this.parentData.driverName : 'N/A';
    this.driverData.mobileNumber = this.parentData.driverMobile ? this.parentData.driverMobile : 'N/A';
    this.driverData.os_version = this.parentData.os_version ? this.parentData.os_version : 'N/A';
    this.driverData.ram = this.parentData.ram ? this.parentData.ram : 'N/A';
    this.driverData.model = this.parentData.model ? this.parentData.model : 'N/A';
    this.driverData.profilePic = this.parentData.profilePic ? this.parentData.profilePic : 'assets/avatar.png';
    this.driverData.licenceNumber = this.parentData.licence.no ? this.parentData.licence.no : 'N/A';
    this.driverData.expiry_date = this.parentData.licence.expiry_date ? this.timeService.toShortDate(this.parentData.licence.expiry_date) : 'N/A';
    this.driverData.driver_type = this.parentData.attached_driver_data ? this.parentData.attached_driver_data.driver_type : '';
    if (this.driverData.driver_type) {
      if (this.driverData.driver_type == 'contracted') {
        this.driverData.driver_type = 'Contracted'
      } else if (this.driverData.driver_type == 'aggregated') {
        this.driverData.driver_type = 'Aggregated'
      } else {
        this.driverData.driver_type = 'Temporary'
      }
    }
    this.driverData.vehicle_no = this.parentData.attached_driver_data ? this.parentData.attached_driver_data.vehicle_no : '';
    this.driverData.truck_type = this.parentData.attached_driver_data ? this.parentData.attached_driver_data.vehicle_type.name : '';
    this.driverData.smartPhone = this.parentData.attached_driver_data ?
      this.parentData.attached_driver_data.has_smart_phone ? 'Yes' : 'No' :
      this.parentData.has_smart_phone ? 'Yes' : 'No';

  }

  closeDialog() {
    this.dialog.close();
  }

}
